//ParcelSymbol.ts ==============================================================
import "../Util/Prototypes";

import * as Settings from "../Settings";
import * as Util_App from "./Util_App";
import * as Util from "./Util";

import Color from "@arcgis/core/Color";

let prevBasemap: string = "";

//Set parcel symbology dark or light based on basemap.
export function setParcelSymbol(basemapName: string) {
   if (Settings.darkBasemapWords.length > 0) {

      if (basemapName !== prevBasemap) {
         let found: boolean = false;

         for (const darkWord of Settings.darkBasemapWords) {
            if (basemapName.Contains(darkWord)) {
               found = true;
               break;
            }
         }

         let newColor = Settings.forLightBasemap;
         if (found) {
            newColor = Settings.forDarkBasemap;
         }

         /*const layer = Util_App.getOperationalLayerById("." + Settings.parcelLayerName) as __esri.Layer;*/ /*CUSTOM! Poway*/
         const layer = Util_App.getOperationalLayerById(Settings.parcelOutlineLayerName) as __esri.Layer; /*CUSTOM! Poway*/
         if (layer) {
            if (layer.type === "vector-tile") {
               const vectorTileLayer = layer as __esri.VectorTileLayer;
               //Util.logMsg("Vector Tile: " + vectorTileLayer.id, vectorTileLayer);

               if (vectorTileLayer.currentStyleInfo) {
                  const styleLayers = vectorTileLayer.currentStyleInfo.style.layers;

                  for (const sl of styleLayers) {
                     if (sl.type === "line") {
                        //Util.logMsg("Style Layer: " + sl.id, sl);
                        const paintProperties = vectorTileLayer.getPaintProperties(sl.id);
                        paintProperties["line-color"] = newColor;
                        vectorTileLayer.setPaintProperties(sl.id, paintProperties);
                     }
                  }
               }

            } else if (layer.type === "feature") {
               const featureLayer = layer as __esri.FeatureLayer;
               if (featureLayer.renderer) {
                  const simpleRenderer = featureLayer.renderer as __esri.SimpleRenderer;

                  const renderer = simpleRenderer.clone();
                  const polySym = renderer.symbol as __esri.SimpleFillSymbol;

                  if (renderer.symbol && polySym.outline) {
                     //polySym.outline.color = Color.fromArray(newColor); //CUSTOM! Poway - Color.fromArray not working correctly.
                     polySym.outline.color = newColor;
                     featureLayer.renderer = renderer;
                  }
               }
            }
         }

         //CUSTOM! Poway
         if (found) {
            turnOnOffBasemapLayers(Settings.BasemapToggleLayersDark, true);
            turnOnOffBasemapLayers(Settings.BasemapToggleLayersLight, false);
         } else {
            turnOnOffBasemapLayers(Settings.BasemapToggleLayersDark, false);
            turnOnOffBasemapLayers(Settings.BasemapToggleLayersLight, true);
         }

         prevBasemap = basemapName;

         //=================================
      //   if (layer.renderer) {
      //      const simpleRenderer = layer.renderer as __esri.SimpleRenderer;

      //      const renderer = simpleRenderer.clone();
      //      const polySym = renderer.symbol as __esri.SimpleFillSymbol;

      //      if (renderer.symbol && polySym.outline) {
      //         polySym.outline.color = Color.fromArray(newColor);
      //         layer.renderer = renderer;
      //      }
      //   }
      //   prevBasemap = basemapName;
      }
   }

} //End function.

//CUSTOM! Poway
function turnOnOffBasemapLayers(basemapToggleLayers: any, visible: boolean) {
   Util.logMsg("basemapToggleLayers: ", basemapToggleLayers);
   Util.logMsg("visible: ", visible);
   let BasemapLayersID: any = Util_App.getOperationalLayerById(basemapToggleLayers.split(',')[0].trim());
   for (const sublayer of BasemapLayersID.allSublayers.items) {
      if (sublayer.title === basemapToggleLayers.split(',')[1].trim()) {
         //Turn on or off sublayer and all child sublayers
         sublayer.visible = visible;
         setChildSublayerVisibility(sublayer, visible);
      }
   }
} //End function.

//CUSTOM! Poway
//Turn on a sublayer and all it's child sublayers.
export function setChildSublayerVisibility(subLayerName: any, visible: boolean): any {
   if (subLayerName.sublayers) {
      for (const sublayer of subLayerName.sublayers.items) {
         sublayer.visible = visible;
         if (sublayer.sublayers) {
            setChildSublayerVisibility(sublayer, visible);
         }
      }
   }
} //End function.
